// extracted by mini-css-extract-plugin
export var container = "_uq-0";
export var table = "_uq-2";
export var tableWrapper = "_uq-1";